import { Button } from "react-bootstrap";
import { DataGrid, DateRangeBox, LoadPanel, Tooltip } from "devextreme-react";
import { useTranslation } from "react-i18next";
import { IListViewCreateDependedDocumentAction } from "./IListViewCreateDependedDocumentAction";
import ThreeDots from "../../assets/img/svg/ThreeDots";
import { IListViewCreateMoreActions } from "./IListViewCreateMoreAction";

interface IProps {
  toolbarOptions?: {
    hidePostButton: boolean;
    hideCloneButton: boolean;
    hideTransactionButton: boolean;
  };
  handleOpenHierarchy: () => void;
  handleDeleteClick: () => void;
  handleCreateNewClick: () => void;
  handleSearchTextChange: (e: any) => void;
  handleOpenMoreActions: () => void;
  setShowDateRangeBox: (e: boolean) => void;
  selectedItem: any | undefined;
  createMoreActionsVisible: boolean;
  handleCloneClick: () => void;
  createDocumentActions?: IListViewCreateDependedDocumentAction[];
  uniqueId: string;
  createMoreActions?: IListViewCreateMoreActions[];
  handlePostDocumentClick: () => void;
  handleEditClick: () => void;
  createDocumentActionVisible: boolean;
  handleComponentRefresh: () => void;
  handleClick: () => void;
  handleCreateDocumentActionPopupButtonClick: () => void;
  setCreateDocumentActionVisible: (e: boolean) => void;
  handleCreateDocumentAction: (action: IListViewCreateDependedDocumentAction) => void;
  handleCancelDocumentClick: () => void;
  handleOpenDocumentTransactions: () => void;
  setCreateMoreActionsVisible: (e: boolean) => void;
  children: any;
}
const NewDocumentListViewToolbar = ({
  toolbarOptions,
  handleDeleteClick,
  handleOpenDocumentTransactions,
  handleCreateNewClick,
  handleSearchTextChange,
  setShowDateRangeBox,
  children,
  selectedItem,
  handleOpenMoreActions,
  handleClick,
  handleCloneClick,
  setCreateMoreActionsVisible,
  createDocumentActions,
  handleCancelDocumentClick,
  uniqueId,
  createMoreActions,
  handleComponentRefresh,
  handleCreateDocumentActionPopupButtonClick,
  handlePostDocumentClick,
  handleCreateDocumentAction,
  handleEditClick,
  createDocumentActionVisible,
  setCreateDocumentActionVisible,
  createMoreActionsVisible,
  handleOpenHierarchy
}: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={"d-flex flex-wrap"}>
      <Button size={"sm"} variant="" className="btn btn-primary mb-3" onClick={handleCreateNewClick}>
        {t("CreateNew")}
      </Button>
      {/*<input*/}
      {/*  onChange={handleSearchTextChange}*/}
      {/*  type="text"*/}
      {/*  className="ms-2 listView-input"*/}
      {/*  style={{*/}
      {/*    height: "30px",*/}
      {/*    borderRadius: "5px",*/}
      {/*    padding: "5px 10px",*/}
      {/*    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",*/}
      {/*    fontSize: "12px",*/}
      {/*    color: "#333"*/}
      {/*  }}*/}
      {/*  placeholder={t("search text...")}*/}
      {/*/>*/}
      <div className={"flex-grow-1"}></div>
      <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2 ms-2" onClick={() => setShowDateRangeBox(true)}>
        <i className="fa-solid fa-calendar"></i>
      </Button>

      {!toolbarOptions?.hideCloneButton && (
        <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handleCloneClick}>
          <i className="fa-solid fa-clone me-2"></i>
          {t("Clone")}
        </Button>
      )}

      {createDocumentActions && createDocumentActions.length > 0 && (
        <>
          <Button
            id={`createDocumentActionsButton_${uniqueId}`}
            size={"sm"}
            variant=""
            className="btn btn-light mb-3 me-2"
            disabled={!selectedItem}
            onClick={handleCreateDocumentActionPopupButtonClick}
          >
            <i className="fa-solid fa-pen-to-square me-2"></i>
            {t("CreateDocument")}
          </Button>
          <Tooltip
            target={`#createDocumentActionsButton_${uniqueId}`}
            position="bottom"
            visible={createDocumentActionVisible}
            onHidden={() => {
              setCreateDocumentActionVisible(false);
            }}
            hideOnOutsideClick={true}
          >
            <b>
              {createDocumentActions.map((action, index) => (
                <div className={"text-start my-2"} key={index}>
                  <Button size={"sm"} variant="" className="btn btn-light w-100" disabled={!selectedItem} onClick={() => handleCreateDocumentAction(action)}>
                    {action.title}
                  </Button>
                </div>
              ))}
            </b>
          </Tooltip>
        </>
      )}

      <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handleEditClick}>
        <i className="fa-solid fa-pen-to-square me-2"></i>
        {t("Edit")}
      </Button>
      <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" onClick={handleDeleteClick} disabled={!selectedItem}>
        <i className="fa-solid fa-trash me-2"></i>
        {t("Delete")}
      </Button>
      {!toolbarOptions?.hidePostButton && (
        <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handlePostDocumentClick}>
          <i className="fa-solid fa-circle-check me-2"></i>
          {t("Post")}
        </Button>
      )}
      <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handleCancelDocumentClick}>
        <i className="fa-solid fa-ban me-2"></i>
        {t("Cancel")}
      </Button>
      {!toolbarOptions?.hideTransactionButton && (
        <Button size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handleOpenDocumentTransactions}>
          <i className="fa-solid fa-list me-2"></i>
          {t("Transactions")}
        </Button>
      )}

      <>
        <Button id={`moreAction_${uniqueId}`} size={"sm"} variant="" className="btn btn-light mb-3 me-2" disabled={!selectedItem} onClick={handleClick}>
          <ThreeDots />
        </Button>
        <Tooltip
          target={`#moreAction_${uniqueId}`}
          position="bottom"
          visible={createMoreActionsVisible}
          onHidden={() => {
            setCreateMoreActionsVisible(false);
          }}
          hideOnOutsideClick={true}
        >
          <b className="d-flex flex-column">
            {createMoreActions?.map((action, index) => (
              <div className={"text-start my-2"} key={index}>
                <Button size={"sm"} variant="" className="btn btn-light w-100" disabled={!selectedItem} onClick={handleOpenMoreActions}>
                  {action.title}
                </Button>
              </div>
            ))}
            <Button
              size={"sm"}
              variant=""
              className="btn btn-light mb-2 me-2 w-100"
              disabled={!selectedItem}
              onClick={() => {
                handleOpenHierarchy();
                setCreateMoreActionsVisible(false);
              }}
            >
              <i className="fa-solid fa-sitemap me-2"></i>
              {t("Hierarchy")}
            </Button>
            <Button size={"sm"} variant="" className="btn btn-light w-100" disabled={!selectedItem} onClick={handleComponentRefresh}>
              <i className="fa-solid fa-rotate-right me-2"></i>
              {t("Refresh")}
            </Button>
          </b>
        </Tooltip>
      </>
    </div>
  );
};

export default NewDocumentListViewToolbar;
